import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const listarResultadosEncuestas = async ({ token, desde, hasta, callbacks }) => {
    let url = `${ENTITY_URL.ADMIN.ENCUESTA.RESULTADOS}`;
    const params = {};
    if (desde) params.desde = desde;
    if (hasta) params.hasta = hasta;

    const response = await connection({
        method: 'GET',
        url,
        extraHeaders: { token },
        params
    });
    if (typeof callbacks === "function") callbacks(response);
};

export default listarResultadosEncuestas;
